import styled from 'styled-components';
import { PropertyCardMixin } from '../../mixins/components/PropertyCardMixin';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
export var StyledPropertyCard = /*#__PURE__*/styled.article.withConfig({
  shouldForwardProp: doNotForwardTransientProp(['loading'])
}).withConfig({
  displayName: "StyledPropertyCard",
  componentId: "c11n-8-111-1__sc-g2ckw9-0"
})(["", ""], PropertyCardMixin);